export default "__VITE_PUBLIC_ASSET__7c50c1f4__"